import React from 'react';
import { useTheme } from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { Tooltip, TooltipPlacement } from '../../../../display/tooltip';
import { StyledIconButton } from '../styled';

export interface FullscreenButtonProps {
  isFullscreen?: boolean;
  onFullscreenToggle?: () => void;
}

export const FullscreenButton: React.FC<FullscreenButtonProps> = ({
  isFullscreen = false,
  onFullscreenToggle,
}) => {
  const theme = useTheme();

  return (
    <Tooltip
      title={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
      placement={TooltipPlacement.Top}
    >
      <StyledIconButton onClick={onFullscreenToggle}>
        <SystemIcon
          iconName={isFullscreen ? 'FullscreenExit' : 'CornersOut'}
          style={{
            color: theme.palette.text.main,
            fontSize: '18px',
          }}
        />
      </StyledIconButton>
    </Tooltip>
  );
};
